var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPanelObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M-18811-9319a10.014 10.014 0 0 1 10-10 9.88 9.88 0 0 1 4.994 1.337 2.5 2.5 0 0 1 1.256-.337 2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1-2.5 2.5 2.5 2.5 0 0 1-2.5-2.5 2.4 2.4 0 0 1 .059-.533 7.945 7.945 0 0 0-3.809-.967 8.01 8.01 0 0 0-8 8 8.011 8.011 0 0 0 8 8 8.009 8.009 0 0 0 8-8 7.9 7.9 0 0 0-.613-3.078 2.5 2.5 0 0 0 1.6-1.3A9.884 9.884 0 0 1-18791-9319a10.013 10.013 0 0 1-10 10 10.018 10.018 0 0 1-10-10z",
    opacity: 0.3,
    transform: "translate(18813 9331)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "colorable",
    cx: 4,
    cy: 4,
    r: 4,
    opacity: 0.997,
    transform: "translate(8 8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanelObject);
export default __webpack_public_path__ + "static/media/left-panel-object.de9d42bf8c4e7157e582493aeea2f519.svg";
export { ForwardRef as ReactComponent };